import { wdyrReady } from './wdyr';
import './lib/sentryInit';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'mapbox-gl/dist/mapbox-gl.css';
import { App } from './App';
import { isProductionEnv } from 'utils/env';
import * as Sentry from '@sentry/react';
import { reportWebVitals } from './reportWebVitals';

if (isProductionEnv) {
  //hotjar.initialize(1782133, 6);
}

// Nem o ChunkErrorBoundary (componentDidCatch) nem onRecoverableError disparam pra esse
// erro — ou seja, ele é genuinamente NÃO CAPTURADO por nenhum Error Boundary da árvore.
// onUncaughtError é o gancho nativo do React 18 EXATAMENTE pra esse caso (substitui o
// console.error padrão do React quando nenhum boundary existe acima do ponto do erro) —
// só ele nos dá o componentStack real aqui.
const root = createRoot(document.getElementById('root'), {
  onUncaughtError: (error, errorInfo) => {
    console.error('React onUncaughtError:', error, errorInfo?.componentStack);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo?.componentStack } },
      tags: { source: 'onUncaughtError' },
    });
  },
  onRecoverableError: (error, errorInfo) => {
    console.error('React onRecoverableError:', error, errorInfo?.componentStack);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo?.componentStack } },
      tags: { source: 'onRecoverableError' },
    });
  },
});
// aguarda why-did-you-render terminar de instrumentar os hooks do React antes do 1º render
// (ver comentário em wdyr.ts) — sem isso, "Rendered more hooks than during the previous render".
wdyrReady.then(() => root.render(<App />));

reportWebVitals(metric => {
  Sentry.addBreadcrumb({
    category: 'web-vitals',
    message: metric.name,
    level: 'info',
    data: { value: metric.value, rating: metric.rating },
  });
  Sentry.setMeasurement(metric.name, metric.value, metric.name === 'CLS' ? '' : 'millisecond');
});
